import { defineComponent as _defineComponent } from 'vue'
import SnapSearchTabV2 from 'library-@/components/snap-business/search-tab-v2';
import _ from 'lodash';
import $ from 'jquery';

import LeftNav from './components/LeftNav.vue';
import FieldView from './components/FieldView.vue';
import OperatorView from './components/OperatorView.vue';
import FormatView from './components/FormatView.vue';
import { useI18n } from '@/composables/useI18n';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchHelper',
  setup(__props) {

const { map, get, forEach, debounce } = _;

const { t } = useI18n();

const definedType = {
    searchableFields: 'searchableFields',
    searchSyntax: 'searchSyntax',
    numberFormat: 'numberFormat',
};

const searchTabs = [
    {
        'key': definedType.searchableFields,
        '$i18Text': t('searchHelper["Searchable Fields"]')
    },
    {
        'key': definedType.searchSyntax,
        '$i18Text': t('searchHelper["Search Syntax"]')
    },
    {
        'key': definedType.numberFormat,
        '$i18Text': t('searchHelper["Number Format"]')
    }
];

const specialTabs = map(searchTabs, item => item.key);

const currentMode = ref(definedType.searchableFields);

const isFixed = ref(false);

const currentNav = ref('');

const navList = ref<{ nav: string }[]>([]);

onMounted(() => {
    bindEvent();
});

onUnmounted(() => {
    offEvent();
});

function backToTop() {
    nextTick(() => window.scrollTo(0, 0));
}

function bindEvent() {
    $(window).on('scroll.SearchHelper', () => {
        if ($(window).scrollTop() > 175) {
            if (!isFixed.value) {
                isFixed.value = true;
                nextTick(() => {
                    const $width = $('.search-helper-comp__table');
                    const $height = $('.search-helper-comp__nav');
                    $('.search-helper-comp__nav').outerWidth(`${$width.outerWidth()}px`);
                    $('.search-helper-comp__fixedSpace').outerHeight(`${$height.outerHeight()}px`);
                });
            }
        } else {
            if (isFixed.value) {
                isFixed.value = false;
                nextTick(() => {
                    $('.search-helper-comp__nav').outerWidth('100%');
                });
            }
        }
        nextTick(() => debounceScrollingUpdateStatus());
    });
}

function offEvent() {
    $(window).off('scroll.SearchHelper');
}

function shiftTab(nav) {
    currentMode.value = nav.key;
}

function updateNavHandler(data) {
    navList.value = data;
    currentNav.value = get(data, '[0].nav', '');
    isFixed.value = false;
    backToTop();
}

function shiftNavHandler(newNav) {
    nextTick(() => {
        const baseHeight = $(window).scrollTop() || 0;
        const targetOffsetHeight = $(newNav)[0] && $(newNav)[0].getBoundingClientRect ? $(newNav)[0].getBoundingClientRect().top : 0;
        window.scrollTo(0, baseHeight + targetOffsetHeight - 100);
    });
}

function scrollingUpdateStatus() {
    const isInView = pos => {
        return pos >= 0 && pos <= document.body.clientHeight;
    };
    const isToBottom = () => {
        const $window = $(window);
        const scrollTop = $window.scrollTop();
        const windowHeight = $window.height();
        const scrollHeight = $(document).height();
        return scrollTop + windowHeight === scrollHeight;
    };
    const visible: Record<'body'|'top'|'bottom', { nav: string }[]> = {
        body: [],
        top: [],
        bottom: []
    };
    forEach(navList.value, (iNav, originIndex) => {
        const { nav } = iNav;
        const { top, bottom } = $(iNav.nav).parent()[0].getBoundingClientRect();
        let visibleArea = '';
        if (top < 0 && bottom > document.body.clientHeight) {
            visibleArea = 'body';
        } else if (isInView(top)) {
            visibleArea = 'top';
        } else if (isInView(bottom)) {
            visibleArea = 'bottom';
        }
        if (visibleArea) {
            visible[visibleArea].push({
                nav,
                visibleArea: visibleArea,
                originIndex
            });
        }
    });

    // 当前锚点判断优先级： body > top(滚动条底部的时候，current为最后一个top) > bottom
    const updateFn = pos => {
        currentNav.value = visible[pos][0].nav;
    };
    if (visible.body.length) {
        updateFn('body');
    } else if (visible.top.length) {
        if (isToBottom()) {
            const last = visible.top.length - 1;
            currentNav.value = visible.top[last].nav;
        } else {
            updateFn('top');
        }
    } else if (visible.bottom.length) {
        updateFn('bottom');
    }
}

const debounceScrollingUpdateStatus = debounce(scrollingUpdateStatus, 100);

return { __sfc: true,map, get, forEach, debounce, t, definedType, searchTabs, specialTabs, currentMode, isFixed, currentNav, navList, backToTop, bindEvent, offEvent, shiftTab, updateNavHandler, shiftNavHandler, scrollingUpdateStatus, debounceScrollingUpdateStatus, SnapSearchTabV2, LeftNav, FieldView, OperatorView, FormatView }
}

})